import { useEffect, useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { checkMfaBeforeLoad } from '~/utils/beforeLoad'

import { ContentWrapper, Flex, Tabs } from '~/components/elements'
import { Contacts } from '~/components/profile/Contacts'
import { OutageCommunicationsPreference } from '~/components/profile/OutageCommunicationPreference'
import { useRootStore } from '~/store/RootStore'

export const Route = createFileRoute('/_authenticated/profile/')({
  beforeLoad: checkMfaBeforeLoad,
  component: ProfilePage,
})

function ProfilePage() {
  const { app } = useRootStore()
  const [activeTab, setActiveTab] = useState('Details')

  useEffect(() => {
    // fetch the address fields
    app.getAddressFieldsLookupData()
  }, [])

  const tabItems = [
    {
      label: 'Details',
      onClick: (label: string) => setActiveTab(label),
    },
    {
      label: 'Communications',
      onClick: (label: string) => setActiveTab(label),
    },
  ]

  return (
    <ContentWrapper>
      <Flex alignitems="center" justifycontent="center">
        <Tabs tabs={tabItems} />
      </Flex>
      {activeTab === 'Details' && <Contacts />}
      {activeTab === 'Communications' && <OutageCommunicationsPreference />}
    </ContentWrapper>
  )
}
